var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.08778C9.7 -1.42846 2 3.37995 2 10.1597C2 16.938 7.628 20.5503 11.7468 23.7847C13.2 24.9251 14.6 26 16 26M16 5.08778C22.3 -1.42846 30 3.37995 30 10.1597C30 16.9394 24.372 20.5517 20.2532 23.7861C18.8 24.9251 17.4 26 16 26M16 5.08778L13.9 9.27023L18.8 12.7556L14.6 17.6351L17.4 20.4234L16 26",
    stroke: "#8E3B00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakHeart);
export default __webpack_public_path__ + "static/media/breakHeart.f5c2b7d65fda6a36f53314ce1a8d4cb7.svg";
export { ForwardRef as ReactComponent };